import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const PAYMENT_STATUSES = [
  "pending",
  "cancelled",
  "expired",
  "failed",
  "paid",
  "completed",
  "processing",
];

export type typePayment = (typeof PAYMENT_STATUSES)[number];

export const DEFAULT_PAYMENT = {
  uuid: "",
  id: "",
  amount: "",
  status: PAYMENT_STATUSES[0] as typePayment,
  expiredAt: "",
  qrCode: "",
};

const initialState = {
  payment: DEFAULT_PAYMENT,
  expiredDialog: {
    open: false,
  },
  cancelledDialog: {
    open: false,
  },
  failedDialog: {
    open: false,
  },
};

export const paymentSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {
    setPayment: (state, action: PayloadAction<typeof initialState.payment>) => {
      state.payment = action.payload;
    },
    setExpiredDialog: (
      state,
      action: PayloadAction<typeof initialState.expiredDialog>
    ) => {
      state.expiredDialog = action.payload;
    },
    setCancelledDialog: (
      state,
      action: PayloadAction<typeof initialState.cancelledDialog>
    ) => {
      state.cancelledDialog = action.payload;
    },
    setFailedDialog: (
      state,
      action: PayloadAction<typeof initialState.failedDialog>
    ) => {
      state.failedDialog = action.payload;
    },
    resetApp: () => initialState,
  },
});

export const {
  setPayment,
  setExpiredDialog,
  setCancelledDialog,
  setFailedDialog,
  resetApp,
} = paymentSlice.actions;

export default paymentSlice.reducer;
